import { useRef, useState } from "react";

/*
 support header slide handler hooks
 */
export const useSupportHeaderSlide = () => {
  const slideStandardRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleSlideToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSlideClose = () => {
    setIsOpen(false);
  };

  return {
    isSlideOpen: isOpen,
    slideStandardRef,
    handleSlideToggle,
    handleSlideClose,
  };
};
